module.exports = __webpack_public_path__ + "static/media/sidebar_essen.595e259c.jpg";